/*
  Accordion "Tem um cupom?" do cart drawer (gaveta).
  Usa delegacao de evento no document para sobreviver ao re-render via AJAX
  do minicart (cart-discount.js / cart-components.js re-injetam o HTML).
  O estado inicial (aberto/fechado) vem do setting `coupon_default_open`,
  renderizado no Liquid via classe `is-open`.
*/
(function () {
  if (window.__couponAccordionBound) return;
  window.__couponAccordionBound = true;

  document.addEventListener('click', function (event) {
    var header = event.target.closest('.coupon-accordion__header');
    if (!header) return;
    var acc = header.closest('.coupon-accordion');
    if (!acc) return;
    // "Sempre aberto" (setting coupon_always_open): nao recolhe.
    if (acc.classList.contains('coupon-accordion--locked')) return;
    event.preventDefault();
    var isOpen = acc.classList.toggle('is-open');
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
})();
